import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Box,
} from "@mui/material";
import { toast } from "react-toastify";

import BondDialogDocumentsSection from "./BondDialogDocumentsSection";

export default function BondCancellationDialog({
  open,
  onClose,
  bond,
  cancellationFile,
  onFileChange,
  isCancelling,
  onSubmit,
  getCancellationInstructionsList,
}) {
  return (
    <Dialog
      open={open}
      onClose={() => !isCancelling && onClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 700, fontSize: "1.3rem" }}>
        Bond Cancellation
      </DialogTitle>
      <DialogContent dividers>
        {bond && (
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>
              Cancellation Details
            </Typography>
            <Typography sx={{ mb: 1 }}>
              <strong>Bond Number:</strong> {bond.bond_number ?? "N/A"}
            </Typography>
            <Typography sx={{ mb: 2 }}>
              <strong>Bond Type:</strong> {bond.bond_type}
            </Typography>

            <Divider sx={{ mb: 2 }} />
            <BondDialogDocumentsSection
              bond={bond}
              getCancellationInstructionsList={getCancellationInstructionsList}
              cancellationFile={cancellationFile}
              disableUpload={isCancelling}
              onFileInputChange={(e) => {
                const file = e.target.files[0];
                const validTypes = [
                  "application/pdf",
                  "application/msword",
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                ];
                if (file && !validTypes.includes(file.type)) {
                  toast.error("Only PDF or Word documents are allowed.");
                  e.target.value = "";
                  return;
                }
                onFileChange(file);
                if (file) toast.success("File selected successfully!");
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: 2 }}>
        <Button onClick={onClose} disabled={isCancelling}>
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={isCancelling || !cancellationFile}
          onClick={onSubmit}
        >
          {isCancelling ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Submit Cancellation"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

BondCancellationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  bond: PropTypes.object,
  cancellationFile: PropTypes.object,
  onFileChange: PropTypes.func.isRequired,
  isCancelling: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  getCancellationInstructionsList: PropTypes.func.isRequired,
};
